import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from '../../../services/Api';
import { authHeader } from '../../../services/auth-header';
import PETOPOPSIConvert from '../PumpSpareInternational/Convert';
import PETOPOMDConvert from '../AraiManufacturing/Convert';

function PETOPOConvert() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [purchaseEnquiryType, setPurchaseEnquiryType] = useState('');
  const [purchaseEnquiryCategory, setPurchaseEnquiryCategory] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}purchaseEnquiry/findById/${id}`, {
          headers: authHeader(),
        });
        setPurchaseEnquiryType(response.data.purchaseenquirytype);
        setPurchaseEnquiryCategory(response.data.purchaseenquirycategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (purchaseEnquiryType === 'Pump Spare' && purchaseEnquiryCategory === 'International') {
      return <PETOPOPSIConvert />;
    } else if (purchaseEnquiryType === 'Manufacturing') {
      return <PETOPOMDConvert />;
    }
    return null;
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>CONVERT PURCHASE ENQUIRY TO PURCHASE ORDER</h6>
          <div className="view-buttons">
            <Link to={`/poenquiryindex/1`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Type:</Form.Label>
                <Form.Select disabled value={purchaseEnquiryType}>
                  <option value="">--Please choose an option--</option>
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Category:</Form.Label>
                <Form.Select disabled value={purchaseEnquiryCategory}>
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {renderPageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default PETOPOConvert;
